import { Weekday } from '@biteinc/enums';
export const menuItemAvailabilitySchema = {
    displayName: 'Menu Item Availability',
    type: 'object',
    fields: {
        isAvailable: {
            type: 'bool',
            isReadOnly: true,
            isHidden: true,
        },
        dates: {
            type: 'array',
            elementType: 'object',
            displayName: 'Dates',
            fields: {
                from: {
                    type: 'timestamp',
                    displayName: 'From',
                    isNullable: true,
                },
                to: {
                    type: 'timestamp',
                    displayName: 'To',
                    isNullable: true,
                },
            },
        },
        days: {
            type: 'array',
            elementType: 'object',
            displayName: 'Days',
            fields: {
                day: {
                    displayName: 'Day',
                    type: 'stringEnum',
                    enum: Weekday,
                    ui: 'dropdown',
                },
                from: {
                    type: 'dayTimestamp',
                    displayName: 'From',
                },
                to: {
                    type: 'dayTimestamp',
                    displayName: 'To',
                },
            },
        },
    },
};
//# sourceMappingURL=menu_item_availability_schema.js.map